import React, { useState } from "react";
import ContactStyles from "../styles/ContactStyles";
import TopPhotoBannerStyles from "../styles/TopPhotoBannerStyles";
import { emailSignup } from "../utils/emailSignup";
import ReactTooltip from "react-tooltip";
import Seo from "../seo";
import { StaticImage } from "gatsby-plugin-image";

const Contact = () => {
  const [confirmation, setConfirmation] = useState(false);
  const [charRemaining, setCharRemaining] = useState(500);

  const charCount = e => {
    const commentLength = e.target.value.length;
    const remaining = 500 - commentLength;
    setCharRemaining(remaining);
  };

  const sendEmail = e => {
    e.preventDefault();

    emailSignup(e, setConfirmation);
    if (typeof window !== `undefined`) {
      const target = document.querySelector(".top-msg");
      target.scrollIntoView();
    }
  };

  return (
    <>
      <Seo
        title="Contact us"
        description="Reach out to partner, sponsor, or recommend a restaurant."
        url="https://www.table-sage.com/contact"
        image="https://res.cloudinary.com/table-sage/image/upload/f_auto,q_auto:good/v1616506310/top-banners/contact-banner_wt9k0d.jpg"
        imageWidth="500"
        imageHeight="375"
      />
      <TopPhotoBannerStyles
        style={{
          display: "grid",
        }}
      >
        <StaticImage
          style={{
            gridArea: "1/1",
            maxHeight: 500,
            minHeight: 500,
          }}
          layout="fullWidth"
          quality={80}
          // This is a presentational image, so the alt should be an empty string
          alt=""
          src={
            "https://res.cloudinary.com/table-sage/image/upload/f_auto,q_auto:good/v1616506310/top-banners/contact-banner_wt9k0d.jpg"
          }
          loading="eager"
          placeholder="blurred"
        />
        <div
          style={{
            // By using the same grid area for both, they are stacked on top of each other
            gridArea: "1/1",
            position: "relative",
            background:
              "linear-gradient(rgba(35, 31, 32, 0.25), rgba(35, 31, 32, 0.25))",
          }}
        >
          <h1 className="header">Get in touch</h1>
          <h2 className="sub-header">
            Join us in building a more conscious dining industry.
          </h2>
        </div>
      </TopPhotoBannerStyles>
      <ContactStyles>
        <p className="top-msg">
          We love hearing from like-minded organizations, curious strangers, and
          passionate foodies.
        </p>
        {confirmation ? (
          <p className="suggest__body-text contact-confirmation">
            Thank you for your submission! We will process it as soon as
            possible. If you prefer to contact us directly, please email
            info@table-sage.com.
          </p>
        ) : (
          <>
            <form
              autoComplete="off"
              className="form"
              id="suggest-form"
              onSubmit={sendEmail}
            >
              <h3 className="suggest__subheader">
                Let us know how you’d like to get involved. Select all that
                apply:
              </h3>
              <div className="suggest__checkboxes">
                <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    className="suggest-check"
                    id="join-the-movt"
                    name="join-the-movt"
                    value="yes"
                  />
                  <label
                    className="suggest__check-label"
                    htmlFor="join-the-movt"
                  >
                    Receive our monthly newsletter
                  </label>
                </div>
                <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    id="partner-eatery"
                    className="suggest-check"
                    name="partner-eatery"
                    value="yes"
                  />
                  <label
                    className="suggest__check-label"
                    htmlFor="partner-eatery"
                  >
                    Partner as an eatery
                  </label>
                </div>
                <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    id="partner-brand"
                    className="suggest-check"
                    name="partner-brand"
                    value="yes"
                  />
                  <label
                    className="suggest__check-label"
                    htmlFor="partner-brand"
                  >
                    Partner as a brand
                  </label>
                </div>
                <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    id="partner-public"
                    className="suggest-check"
                    name="partner-public"
                    value="yes"
                  />
                  <label
                    className="suggest__check-label"
                    htmlFor="partner-public"
                  >
                    Partner as a public institution
                  </label>
                </div>
                {/* <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    className="suggest-check"
                    id="join-rate"
                    name="join-rate"
                    value="yes"
                  />
                  <label className="suggest__check-label" htmlFor="join-rate">
                    Join the waitlist for our Rate tool
                  </label>
                </div> */}

                {/* <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    id="join-plate"
                    className="suggest-check"
                    name="join-plate"
                    value="yes"
                  />
                  <label className="suggest__check-label" htmlFor="join-plate">
                    Join the waitlist for our Plate service
                  </label>
                </div> */}

                <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    className="suggest-check"
                    id="request-press"
                    name="request-press"
                    value="yes"
                  />
                  <label
                    className="suggest__check-label"
                    htmlFor="request-press"
                  >
                    Request press materials
                  </label>
                </div>

                <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    className="suggest-check"
                    id="share-article"
                    name="share-article"
                    value="yes"
                  />
                  <label
                    className="suggest__check-label"
                    htmlFor="share-article"
                  >
                    Recommend an industry news article
                  </label>
                </div>
                <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    className="suggest-check"
                    id="list-restaurant"
                    name="list-restaurant"
                    value="yes"
                  />
                  <label
                    className="suggest__check-label"
                    htmlFor="list-restaurant"
                  >
                    Recommend an eatery
                  </label>
                </div>
                <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    className="suggest-check"
                    id="join-team"
                    name="join-team"
                    value="yes"
                  />
                  <label className="suggest__check-label" htmlFor="join-team">
                    Join our team
                  </label>
                </div>
                {/* <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    className="suggest-check"
                    id="sponsor"
                    name="sponsor"
                    value="yes"
                  />
                  <label className="suggest__check-label" htmlFor="sponsor">
                    Become a sponsor
                  </label>
                </div> */}
                {/* <div className="suggest__check-item">
                  <input
                    type="checkbox"
                    className="suggest-check"
                    id="consultation"
                    name="consultation"
                    value="yes"
                  />
                  <label
                    className="suggest__check-label"
                    htmlFor="consultation"
                  >
                    Request consulting services
                  </label>
                </div> */}
              </div>
              <h3 className="suggest__subheader">
                Provide any relevant information:
              </h3>
              <div className="form__input-container mr-3">
                <input
                  name="first-name"
                  id="first-name"
                  type="text"
                  className="form__input form__input--half-width"
                  required
                />
                <label htmlFor="first-name" className="form__label">
                  Your first name*
                </label>
              </div>
              <div className="form__input-container">
                <input
                  name="last-name"
                  id="last-name"
                  type="text"
                  className="form__input form__input--half-width"
                  required
                />
                <label htmlFor="last-name" className="form__label">
                  Your last name*
                </label>
              </div>
              <div className="form__input-container--hp">
                <input
                  name="hair-color"
                  id="hair-color"
                  type="text"
                  className="form__input form__input--half-width"
                  autoComplete="off"
                />
                <label htmlFor="hair-color" className="form__label">
                  Your hair color*
                </label>
              </div>
              <div className="form__input-container mr-3">
                <input
                  name="business-name"
                  id="business-name"
                  type="text"
                  className="form__input form__input--half-width"
                />
                <label
                  htmlFor="business-name"
                  data-tip="If recommending a business, <br>enter its name. If a potential<br> partner or the press, enter your<br> business/ organization name."
                  className="form__label form__label--with-tooltip"
                >
                  Business/ organization name
                </label>
                <ReactTooltip
                  effect="solid"
                  multiline={true}
                  backgroundColor="#231f20"
                />
              </div>
              <div className="form__input-container">
                <input
                  name="city"
                  id="city"
                  type="text"
                  className="form__input form__input--half-width"
                  required
                />
                <label
                  htmlFor="city"
                  data-tip="If recommending a business,<br> enter the city where it is located.<br>Otherwise, enter your city."
                  className="form__label form__label--with-tooltip"
                >
                  City*
                </label>
                <ReactTooltip
                  effect="solid"
                  multiline={true}
                  backgroundColor="#231f20"
                />
              </div>
              <div className="form__input-container--long">
                <input
                  name="email"
                  id="email"
                  type="email"
                  className="form__input form__input--full-width"
                  required
                />
                <label htmlFor="email" className="form__label">
                  Your email*
                </label>
              </div>
              <div className="form__input-container--long">
                <input
                  name="website"
                  id="website"
                  type="text"
                  className="form__input form__input--full-width"
                />
                <label
                  htmlFor="website"
                  data-tip="If recommending a business,<br>enter its website. Otherwise, enter<br>
              your website (if applicable.)"
                  className="form__label form__label--with-tooltip"
                >
                  Website
                </label>
                <ReactTooltip
                  effect="solid"
                  multiline={true}
                  backgroundColor="#231f20"
                />
              </div>
              <textarea
                name="comments"
                className="form__text-area"
                maxLength="500"
                placeholder="Additional comments..."
                onChange={charCount}
              ></textarea>
              <p className="form__char-count">
                Characters remaining: {charRemaining}
              </p>
              <input type="submit" value="Submit" className="form__button" />
            </form>
            <p className="suggest__body-text mb-8 align-left">
              If you prefer to contact us directly, please email
              info@table-sage.com.
            </p>
          </>
        )}
      </ContactStyles>
    </>
  );
};

export default Contact;
